import { render, staticRenderFns } from "./TableSupplierService.vue?vue&type=template&id=678265c8"
import script from "./TableSupplierService.vue?vue&type=script&lang=js"
export * from "./TableSupplierService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports